import { FormControlLabel, Grid, Radio, RadioGroup } from '@mui/material';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import { isMobile } from 'react-device-detect';
import { withTranslation } from 'react-i18next';
import api from '../../api';
import Bottom from './Bottom';
import PaymentTypeEnum from '../../enums/PaymentTypeEnum';

@inject('commonStore', 'menuStore', 'orderStore')
@observer
class PaymentKSNET extends Component {
  formRef = React.createRef();
  actionUrl = `${process.env.REACT_APP_KSNET_URL}/store/KSPayMobileV1.4/KSPayPWeb.jsp`;
  resultUrl = `${process.env.REACT_APP_SMARTORDER_API_URL}/sales/ksnet`;
  receiveUrl = `${process.env.REACT_APP_SMARTORDER_API_URL}/sales/ksnet/receive`;

  componentDidMount() {
    const { orderStore } = this.props;

    // 결제 방법 기본값을 카드로 설정
    if (!orderStore.paymentMethod) {
      orderStore.setPaymentMethod('1');
    }

    // PC 브라우저인 경우 스크립트 include
    if (!isMobile) {
      const script = document.createElement('script');
      script.src = 'https://code.jquery.com/jquery-1.12.4.min.js';
      script.async = true;
      document.body.appendChild(script);

      const script2 = document.createElement('script');
      script2.src = 'https://kspay.ksnet.to/store/KSPayWebV1.4/js/kspay_web_ssl.js';
      script2.async = true;
      document.body.appendChild(script2);
    }

    window.addEventListener('message', this.handleMessage);
  }

  componentWillUnmount() {
    window.addEventListener('message', this.handleMessage);
  }

  /** 결제방법 변경 */
  handlePayMethodChange = event => {
    this.props.orderStore.setPaymentMethod(event.target.value);
  };

  handleMessage = event => {
    const { type, payload } = event.data;
    if (type === 'receive') {
      this.receive(payload);
    } else if (type === 'close') {
      /* global closeEvent */
      closeEvent();
    }
  };

  receive = payload => {
    const { commonStore, orderStore } = this.props;

    const form = document.createElement('form');
    form.method = 'post';
    form.action = `${this.resultUrl}?companyId=${commonStore.companyId}&storeCode=${commonStore.storeCode}&isLiteOrder=${orderStore.isLiteOrder}`;

    // 가맹점 데이터 추가
    payload.ECHRESERVED01 = `${commonStore.companyId}|${commonStore.storeCode}|${orderStore.isLiteOrder}`;

    // 객체의 각 키-값 쌍에 대해 hidden input을 생성하여 form에 추가
    /* eslint-disable no-unused-vars */
    for (const [key, value] of Object.entries(payload)) {
      const hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = key;
      hiddenInput.value = value != null ? String(value) : '';
      form.appendChild(hiddenInput);
    }

    // 생성된 form을 body에 추가 (DOM에 추가되어야 submit이 동작합니다)
    document.body.appendChild(form);

    // form 제출
    form.submit();

    // 제출 후 body에서 form을 다시 제거
    document.body.removeChild(form);
  };

  /** 결제 진행 */
  pay = async () => {
    const { commonStore, orderStore } = this.props;
    try {
      // 주문 저장
      orderStore.setPaymentType(PaymentTypeEnum.KSNET);
      const response = await api.addOrder(orderStore.orderData);

      // 결제 요청 데이터 세팅
      orderStore.setPaymentData(response.data);
    } catch (error) {
      commonStore.setError(error);
      throw error;
    } finally {
      // 결제 버튼 활성화
      orderStore.setDisablePaymentButton(false);
    }

    if (isMobile) {
      this.formRef.submit();
    } else {
      /* global _pay */
      if (this.formRef) _pay(this.formRef);
    }
  };

  render() {
    const { t, commonStore, menuStore, orderStore } = this.props;
    return (
      <React.Fragment>
        {/* 결제방법 선택 */}
        {menuStore.storeData.isEzwelPayUsed && (
          <Grid item container direction={'column'} spacing={1} style={{ marginTop: '25px' }}>
            <Grid item>
              <span style={{ fontSize: '13pt', fontWeight: 'bold' }}>{t('payment.label.method')}</span>
            </Grid>
            <Grid item>
              <RadioGroup
                aria-label="gender"
                name="gender1"
                value={orderStore.paymentMethod}
                onChange={this.handlePayMethodChange}
              >
                <FormControlLabel value={1} control={<Radio color="primary" />} label={'일반결제'} />
                <FormControlLabel value={0} control={<Radio color="primary" />} label={'이지웰페이'} />
              </RadioGroup>
            </Grid>
          </Grid>
        )}

        <form ref={ref => (this.formRef = ref)} name="payForm" method="post">
          {/************************* 공통 필수 *************************/}
          {/* 결제 수단 */}
          <input type="hidden" name="sndPaymethod" value="1000000000000" />
          {/* 상점 ID */}
          <input type="hidden" name="sndStoreid" value={menuStore.storeData.merchantID} />
          {/* 주문번호 */}
          <input type="hidden" name="sndOrdernumber" value={orderStore.paymentData.orderId} />
          {/* 상품명 */}
          <input type="hidden" name="sndGoodname" value={orderStore.paymentMenuName} />
          {/* 상품가격 */}
          <input type="hidden" name="sndAmount" value={orderStore.paymentAmount} />
          {/* 주문자명 */}
          <input type="hidden" name="sndOrdername" value={orderStore.orderData.userId} />
          {/* Return URL */}
          <input
            type="hidden"
            name="sndReply"
            value={`${isMobile ? this.resultUrl : this.receiveUrl}?companyId=${commonStore.companyId}&storeCode=${commonStore.storeCode}&isLiteOrder=${orderStore.isLiteOrder}`}
          />
          {/* 신용카드 표시 옵션 (C : 전체카드사, C(04) : 삼성카드, C(25) : 해외카드, ...) */}
          <input type="hidden" name="sndShowcard" value="C" />
          {/* 통화코드 */}
          <input type="hidden" name="sndCurrencytype" value="WON" />
          {/* 할부개월수 (0:2:3:...) */}
          <input type="hidden" name="sndInstallmenttype" value="0" />
          {/* 가맹점부담 무이자할부 */}
          <input type="hidden" name="sndInteresttype" value="NONE" />

          {/************************* 공통 옵션 *************************/}
          {/* 문자 인코딩 */}
          <input type="hidden" name="sndCharSet" value="utf-8" />
          {/* 구매자 이메일 */}
          <input type="hidden" name="sndEmail" value="" />
          {/* 구매자 이동전화 */}
          <input type="hidden" name="sndMobile" value={orderStore.orderData.userId} />

          {/************************* 카카오페이 필수 *************************/}
          {/* 카카오페이 상점대표자명 */}
          <input type="hidden" name="sndStoreCeoName" value={''} />
          {/* 카카오페이 연락처 */}
          <input type="hidden" name="sndStorePhoneNo" value={''} />
          {/* 카카오페이 주소 */}
          <input type="hidden" name="sndStoreAddress" value={''} />

          {/************************* 옵션 *************************/}
          {/* 간편결제표시구분 */}
          <input type="hidden" name="sndQpayType" value="1" />
          <input
            type="hidden"
            name="ECHRESERVED01"
            value={`${commonStore.companyId}|${commonStore.storeCode}|${orderStore.isLiteOrder}`}
          />
        </form>

        <Bottom pay={this.pay} />
      </React.Fragment>
    );
  }
}

export default withTranslation()(PaymentKSNET);
